import { fromExtent } from 'ol/geom/Polygon';
import { Stroke, Style } from 'ol/style';
import { color as d3color } from 'd3-color';
import color from 'client/utils/constants/GDS/js/color';
import { Geometry } from 'ol/geom';

export const extentStyle = new Style({
    stroke: new Stroke({
        color: d3color(color.black).copy({ opacity: 0.3 }).formatRgb(),
        width: 1,
        lineDash: [7, 7]
    })
});

export const addExtent = (geometry, styles) => {
    if (!geometry || !(geometry instanceof Geometry)) {
        return new Error('Invalid geometry object');
    }
    const extent = geometry?.getExtent();
    if (extent) {
        const style = extentStyle;
        style.setGeometry(fromExtent(extent));
        styles.push(style);
    }
};
